export default "__VITE_ASSET__CkLTPOvU__"